"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Einstellungen-Modul
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCAdmin
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCAdmin} options.module Modul-Instanz
 */
gc.gis.module.GCAdmin.Panel = function (options)
{

    // options validierung
    gc.gis.assert.isSet(options);
    gc.gis.assert.isInstance(options.module, gc.gis.module.GCAdmin);

    // member initialisieren
    this.module = options.module;
    this._settings = {};

    // content initialisieren
    const options_widget = {
        className: 'gc-admin'
    };
    gc.gis.widget.GCPanel.call(this, options_widget);

    this.element = this._render();
    this._initContent();

    // Handler für Aktualisierung verfügbarer CRS
    /*
    const self = this;
    this.module.map.on(gc.gis.map.GCMapEvent.PROJECTIONS_UPDATED, this, function (evt) {
        self._initCRSList(evt.projections);
    });
     //*/
};
gc.gis.module.GCAdmin.Panel.prototype = Object.create(gc.gis.widget.GCPanel.prototype);

/**
 *
 */
gc.gis.module.GCAdmin.Panel.prototype._initContent = function ()
{
    const self = this;
    let element_hint;

    const form_config = {
        className: 'gc-form-admin',
        controls: [
            {
                label: 'maximale Ausdehnung',
                type: 'advanced',
                active: false,
                controls: [
                    {
                        label: 'Koordinatensystem',
                        name: 'extent_crs',
                        type: 'select',
                        // options: [],
                        // initFunc: function (control) {},
                        // updateFunc wird auch beim initialisieren aufgerufen
                        updateFunc: function () {
                            const projections = self.module.map.getAvailableProjections();
                            const options = [];
                            for (let i = 0; i < projections.length; i++) {
                                options.push({
                                    label: projections[i].label,
                                    value: projections[i].code
                                });
                            }
                            return options;
                        }
                    },
                    {
                        label: 'Ausdehnung (Min. X)',
                        name: 'extent_minx',
                        type: 'text'
                    },
                    {
                        label: 'Ausdehnung (Min. Y)',
                        name: 'extent_miny',
                        type: 'text'
                    },
                    {
                        label: 'Ausdehnung (Max. X)',
                        name: 'extent_maxx',
                        type: 'text'
                    },
                    {
                        label: 'Ausdehnung (Max. Y)',
                        name: 'extent_maxy',
                        type: 'text'
                    },
                    {
                        label: 'aktuellen Kartenausschnitt übernehmen',
                        type: 'button',
                        click: function (evt) {
                            self._initExtentFromMap();
                        }
                    }
                ]
            },
            {
                label: 'Startansicht',
                type: 'advanced',
                active: false,
                // id: 'foo',
                controls: [
                    {
                        label: 'globale Startansicht',
                        name: 'start_view',
                        type: 'select',
                        initFunc: function (control) {
                            gc.gis.iface.onModuleAvailable(self.module, 'GCViews', function (mod_views) {
                                self._mod_views = mod_views;
                                self._mod_views.on(gc.gis.module.GCViewsEvent.VIEW_LOADING_STOPPED, self,
                                    function () {
                                        control.updateOptions(control.updateFunc.call(this));
                                        self._updateCofigForm();
                                    }
                                );
                            })
                        },
                        updateFunc: function () {
                            const options = [];
                            options.push({
                                label: '',
                                value: ''
                            });

                            if (this._mod_views) {
                                const views = this._mod_views.getOwnViews();
                                for (let i = 0, ii = views.length; i < ii; i++) {
                                    options.push({
                                        label: views[i].name,
                                        value: views[i].id
                                    });
                                }
                            }
                            return options;
                        }
                    }
                ]
            },
            {
                label: '3D Viewer',
                type: 'advanced',
                active: false,
                controls: [
                    {
                        label: 'URL',
                        name: 'viewer3d_url',
                        type: 'text'
                    },
                    {
                        label: 'Zielfenster (Target)',
                        name: 'viewer3d_target',
                        type: 'text'
                    },
                    {
                        label: 'max. Maßstab',
                        name: 'viewer3d_maxscaledenom',
                        type: 'scale-selector',
                        scales: [
                            {
                                label: '1:1.000',
                                value: 1000
                            },
                            {
                                label: '1:2.500',
                                value: 2500
                            },
                            {
                                label: '1:5.000',
                                value: 5000
                            },
                            {
                                label: '1:10.000',
                                value: 10000
                            }
                        ]
                    }
                ],
                initFunc: function (control) {
                    if (!gc.gis.iface.isModuleLoaded('GCLink3DViewer'))
                    {
                        control.getElement().hide();
                        gc.gis.iface.onModuleAvailable(self.module, 'GCLink3DViewer', function () {
                            control.getElement().show();
                        });
                    }
                }
            },
            //*/
            /*
            {
                label: 'Ansichten-Galerie',
                type: 'advanced',
                active: false,
                // id: 'foo',
                controls: [
                    {
                        label: 'Ansichten auswählen',
                        name: 'gallery_views',
                        type: 'select',
                        multiple: true,
                        initFunc: function (control) {
                            gc.gis.iface.onModuleAvailable(self.module, 'GCViews', function (mod_views) {
                                self._mod_views = mod_views;
                                self._mod_views.on(gc.gis.module.GCViewsEvent.VIEW_LOADING_STOPPED, self,
                                    function () {
                                        control.updateOptions(control.updateFunc.call(this));
                                        self._updateCofigForm();
                                    }
                                );
                            })
                        },
                        updateFunc: function () {
                            const options = [];
                            if (this._mod_views) {
                                const views = this._mod_views.getOwnViews();
                                for (let i = 0, ii = views.length; i < ii; i++) {
                                    options.push({
                                        label: views[i].name,
                                        value: views[i].id
                                    });
                                }
                            }
                            return options;
                        }
                    }
                ]
            },
             //*/
            {
                label: 'Speichern',
                type: 'submit'
            }
        ],
        validate: function (form, params) {
            // console.debug(form);
            // console.debug(params);
        },
        submit: function (form, params) {
            form.setLoading(true);
            gc.gis.iface.request.ajax({
                label: 'Speichere Konfiguration ... ',
                url: self.module.adminSetConfigUrl,
                data: params,
                success: function () {
                    gc.gis.iface.ui.notify({
                        type: gc.gis.ui.GCNotificationType.INFO,
                        message: 'Konfiguration wurde erfolgreich gespeichert.'
                    });
                    // Einstellungen von Server holen und Formular aktualisieren
                    self._loadAndUpdateFormData();
                },
                finally: function () {
                    form.setLoading(false);
                }
            });
        }
    };

    this.__element_form = gc.gis.util.GCFormRenderer.renderForm(form_config);

    element_hint = jQuery('<p>', {
        'class': 'alert alert-info',
        html: '<strong>Hinweis:</strong> Änderungen werden nur durch Neuladen des Kartenfensters aktiviert.'
    });
    this.element_content.append(element_hint);
    this.element_content.append(this.__element_form.getElement());

    // initial Admin-Konfiguration vom Server holen und Formular aktualisieren
    this._loadAndUpdateFormData();
};


/**
 * Initialisiert das Extent auf Basis der aktuellen Kartenansicht.
 *
 * @protected
 */
gc.gis.module.GCAdmin.Panel.prototype._initExtentFromMap = function ()
{
    const extent = this.module.map.getViewportExtent();

    // TODO bei geographischen Koordinaten 5 Nachkommestellen
    const precision = 1000.0;
    this.__element_form.setValue('extent_crs', this.module.map.getProjection());
    this.__element_form.setValue('extent_minx', Math.round(extent[0] * precision) / precision);
    this.__element_form.setValue('extent_miny', Math.round(extent[1] * precision) / precision);
    this.__element_form.setValue('extent_maxx', Math.round(extent[2] * precision) / precision);
    this.__element_form.setValue('extent_maxy', Math.round(extent[3] * precision) / precision);
};


/**
 * Lädt die Admin-Einstellungen vom Server und aktualisiert die Formularwerte.
 *
 * @protected
 */
gc.gis.module.GCAdmin.Panel.prototype._loadAndUpdateFormData = function ()
{
    const self = this;
    gc.gis.iface.request.ajax({
        label: 'Lade Konfiguration ... ',
        url: self.module.adminGetConfigUrl,
        dataType: gc.gis.util.GCRequestManagerDataType.JSON,
        success: function (data) {
            self._settings = data.results;
            self._updateCofigForm();
        }
    });
};

/**
 * Aktualisiert die Formularwerte anhand der bereits geladenen Einstellungen siehe Member _settings.
 *
 * @protected
 */
gc.gis.module.GCAdmin.Panel.prototype._updateCofigForm = function ()
{
    this.__element_form.setValue('start_view', this._settings.start_view || '');

    /*
    this.__element_form.setValue('gallery_views', this._settings.gallery_views ? this._settings.gallery_views : '');
    //*/

    if (this._settings.max_extent && this._settings.max_extent.crs
        && this._settings.max_extent.minx && this._settings.max_extent.miny
        && this._settings.max_extent.maxx && this._settings.max_extent.maxy) {
        this.__element_form.setValue('extent_crs', this._settings.max_extent.crs);
        this.__element_form.setValue('extent_minx', this._settings.max_extent.minx);
        this.__element_form.setValue('extent_miny', this._settings.max_extent.miny);
        this.__element_form.setValue('extent_maxx', this._settings.max_extent.maxx);
        this.__element_form.setValue('extent_maxy', this._settings.max_extent.maxy);
    }
    else {
        this.__element_form.setValue('extent_minx', '');
        this.__element_form.setValue('extent_miny', '');
        this.__element_form.setValue('extent_maxx', '');
        this.__element_form.setValue('extent_maxy', '');
    }

    this.__element_form.setValue('viewer3d_url', this._settings.viewer3d_url || '');
    this.__element_form.setValue('viewer3d_target',  this._settings.viewer3d_target || '');
    this.__element_form.setValue('viewer3d_target',  this._settings.viewer3d_target || '');
    this.__element_form.get('viewer3d_maxscaledenom').getWidget().setScale(this._settings.viewer3d_maxscaledenom || '');
};